import { h } from 'preact';
import React, { Component } from 'react';
import SearchSVG from '../Components/Search.svg';
import Accordion from '../Components/Accordion';
import { VendorContent } from './VendorContent';
import { makeText } from '../../../util';

export default class Vendors extends Component {
  state = {
    filter: ''
  }

  updateFilter = (e) => this.setState({ filter: e.target.value });

  render() {
    const { vendors, settings, language, dev } = this.props;
    const { filter } = this.state;

    const filteredVendors = vendors
      .filter(v => filter === '' || v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);

    const searchText = makeText(Boolean(dev), settings, 'searchText', language);

    return (
      <div className="pm-features pm-vendors">
        <div className="filter-container">
          <img src={SearchSVG} alt="" />
          <input className="vendor-filter" placeholder={`${searchText}...`} name="filter" value={filter} onChange={this.updateFilter} />
        </div>
        {filteredVendors.map(v => {
          return (
            <Accordion
              key={`vendor-${v._id}`}
              settings={this.props.settings}
              name={<span>{v.name}</span>}
              description={v.name}
              child="vendors"
              language={language}
              value={v}
              content={<VendorContent dev={dev} vendor={v} settings={settings} language={language} />}
              toggle={this.props.toggleVendor}
            />
          );
        }
        )}
      </div>
    );
  }
}
